import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

/** NP20-1238: Kennzeichnung einer Projektverlängerung in Angebotsliste und Vertriebsansicht. */
@Component({
  selector: 'app-extension-badge',
  templateUrl: './extension-badge.component.html',
  styleUrl: './extension-badge.component.scss',
  standalone: true,
  imports: [DatePipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtensionBadgeComponent {
  @Input() extension: boolean | null | undefined = false;
  @Input() extendedUntil: string | null | undefined = null;
}
